<template>
  <atom-info-box priority="warning" heading-element-size="h4">
    <template #heading>
      Your email change is awaiting confirmation.
    </template>
    <p>
      You have requested to change your email to <strong> {{ user.unconfirmedEmailAddress }}</strong>.
    </p>
    <p>
      You must confirm your new email address before using it.
    </p>
    <atom-button label="Resend confirmation email" size="small" @click="resendEmail" />
    <atom-button label="Cancel email change request" size="small" @click="cancelEmailChangeRequest"/>
  </atom-info-box>
</template>

<script lang="ts">
import type { JsonUserAccount } from "authentication/js/api/user-account.api";
import type { PropType } from "vue";
import {
  cancelAuthenticationEmail,
  resendAuthenticationEmail,
} from "authentication/js/api/user-email-authentication.api";
import { useUserAccountsStore } from "authentication/stores/user-accounts.store";
import AtomButton from "core/components/atom/button/AtomButton.vue";
import AtomInfoBox from "core/components/atom/infoBox/AtomInfoBox.vue";
import showFlashMessage from "core/js/flashmessage/flash-message";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    AtomButton,
    AtomInfoBox,
  },
  props: {
    user: { type: Object as PropType<JsonUserAccount>, required: true },
  },
  setup() {
    const { refreshUserAccounts } = useUserAccountsStore();

    return {
      refreshUserAccounts,
    };
  },
  methods: {
    resendEmail() {
      resendAuthenticationEmail();
      showFlashMessage("Another confirmation email has been sent.", { displayType: "success" });
    },
    async cancelEmailChangeRequest() {
      await cancelAuthenticationEmail(this.user.id);
      await this.refreshUserAccounts();
      showFlashMessage("Your email change request has been cancelled.", { displayType: "success" });
    },
  },
});
</script>
